{
  "unit": {
    "box": "doos | dozen",
    "bundle": "bundel | bundels",
    "bus": "bus | bussen",
    "can": "blik | blikken",
    "gram": "gram | gram",
    "kilogram": "kilogram | kilogram",
    "overbox": "overdoos | overdozen",
    "pallet": "pallet | pallets",
    "piece": "stuk | stuks",
    "pouch": "zakje | zakjes",
    "roll": "rol | rollen",
    "set": "set | sets",
    "tube": "koker | kokers",
    "unknown": ""
  },
  "error": {
    "request": {
      "generic": "Error while calling the API."
    }
  }
}
